export const CART_REQUEST = "cart/request";
export const CART_ERROR = "cart/error";
export const DELET_CART = "cart/delet";
export const CART_SUCCESS = "cart/success";

//
export const CART_ADD_SUCCESS = "cart/addSuccess";
export const CART_QTT_CHANGE = "cart/qttChange";
